(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('footer', Footer)

    /** @ngInject */
    function Footer(PATHS) {
        function FooterController() {
            const vm = this;

            init();

            function init() {
                vm.year = moment().format('YYYY');
            }
        }

        return {
            bindToController: true,
            controller: FooterController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/Footer/Footer.html`,
            scope: {}
        }
    }
}());